import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { EstadoFaseAnualModel, ResponseEstadoFaseAnualModel } from 'src/app/model/EstadoFaseAnual.model';
import { EstrategiasAreasModel, FaseAnualModel, ResponseFaseAnualModel, YearsModel } from 'src/app/model/FaseAnual.model';
import { ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service';

import Swal from 'sweetalert2';
import { JardinPlanMejoraComponent } from '../../jardin-plan-mejora.component';

@Component({
  selector: 'app-fase-anual-seguimiento',
  templateUrl: './fase-anual-seguimiento.component.html',
  styleUrls: ['./fase-anual-seguimiento.component.css']
})
export class FaseAnualSeguimientoComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  @Input() simulacion: boolean;
  cargando: boolean;
  cambios: boolean;
  alternativo : boolean = false;
  dataJardin = new JardinModel();
  faseAnualData = new FaseAnualModel();
  uniEducativa = new UnidadEducativaModel();
  estadoFaseAnual = new  EstadoFaseAnualModel();
  click = false;

  constructor(
    @Inject(JardinPlanMejoraComponent) private parent: JardinPlanMejoraComponent,
    private api: apiService,
    private planMejoraService: PlanMejoraService
    ) {}

    ngOnInit(): void {     
      this.click = false;
      this.cargando = true;
      this.cambios = false;
      this.cargaInicial();
    }
  
    change() {
      this.cambios = true;
    }
    
    cargaInicial(){
      this.dataJardin = this.api.dataJardin;
      this.unidadEducativa(this.dataJardin);
      this.getFaseAnual(this.dataJardin);
      this.getEstadosFaseAnualAnio(this.dataJardin);
    }
  
    getPeriodoJardin(periodo){
      let periodoString = "2021"
      if(periodo == "Alternativo"){
        periodoString = "2024-2027"
        this.alternativo = true;
      }else{
        periodoString = "2024-2027"
      }
      return periodoString
    }

    
  
    unidadEducativa(dataJardin:JardinModel){
        this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
          this.uniEducativa = response.payload;  
        },
        (err) => {
          console.log(err)
        });      
    }
  
    getFaseAnual(dataJardin:JardinModel){
      this.planMejoraService.API_POST_getFaseAnual(dataJardin.id).subscribe((response:ResponseFaseAnualModel) => {
        this.faseAnualData = response.payload;  
        this.cargando = false;
      },
      (err) => {
        console.log(err)
      });      
    }

    getEstadosFaseAnualAnio(dataJardin:JardinModel){
      this.planMejoraService.API_POST_getEstadosFaseAnualAnio(dataJardin.id).subscribe((response: ResponseEstadoFaseAnualModel) => {
        this.estadoFaseAnual = response.payload;  
      },
      (err) => {
        console.log(err)
      });      
    }
  
    guardarFaseAnual(anio : YearsModel){
      if (this.click == false) { 
        this.click = true;
        this.planMejoraService.API_POST_guardarFaseAnualSeguimiento(this.dataJardin.id,anio.idFaseAnualAnio,anio.orden,this.faseAnualData).subscribe((response:any) => {
          this.cambios = false;
          this.ngOnInit();
          Swal.fire({
            title: 'Realizado!',
            text: 'Guardado con éxito',
            icon: 'info',
            confirmButtonText: 'OK'
          })
        },
        (err) => {
          console.log(err)
        });   
      }
    }

    guardarTodoFaseAnual(){
      if (this.click == false) { 
        this.click = true;
        let anios = this.faseAnualData.anios;
        anios.forEach(anio => {
          this.planMejoraService.API_POST_guardarFaseAnualSeguimiento(this.dataJardin.id,anio.idFaseAnualAnio,anio.orden,this.faseAnualData).subscribe((response:any) => {
            this.cambios = false;
            this.click = false
          },
          (err) => {
            console.log(err)
          }); 
        });
      }
    }

    finalizarAnioSeguimientoFaseAnual(anioData: YearsModel){
      this.planMejoraService.API_POST_finalizarFaseAnualSeguimiento(this.dataJardin.id,anioData.idFaseAnualAnio).subscribe((response:any) => {
        this.irAFinalizar(anioData.anio);
      },
      (err) => {
        console.log(err)
      });          
    }

    validarFinalizar(anioData : YearsModel){
      let errores = [];
      Swal.fire({
        title: 'Este proceso no se puede deshacer, ¿Desea continuar?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.planMejoraService.API_POST_guardarFaseAnualSeguimiento(this.dataJardin.id,anioData.idFaseAnualAnio,anioData.orden,this.faseAnualData).subscribe((response:any) => {
          },
          (err) => {
            console.log(err)
          });
          anioData.areas.forEach(area => {
            area.subdimensiones.forEach(subdimension => {
              subdimension.estrategias.forEach(estrategia => {
                if (this.validarEstrategia(estrategia, area.orden) != "") {
                  errores.push(this.validarEstrategia(estrategia, area.orden));
                }
              });
            });
          });
          if (errores.length > 0) {
            Swal.fire({
              title: 'Faltan campos',
              text: errores[0],
              icon: 'error',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                this.ngOnInit();
              }
            });
          } else {
            this.finalizarAnioSeguimientoFaseAnual(anioData);
          }
        }
       
      })
    }

    validarEstrategia(estrategia : EstrategiasAreasModel, areaOrden : number) : string{
      let error = ""
      if (this.campoVacio(estrategia.acciones[0].seguimiento)){
        error = "Falta completar seguimiento en la Estrategia " + estrategia.orden + " de la Dimensión "+ areaOrden;
      }
      if(typeof estrategia.acciones[1] != 'undefined'){
        if (this.campoVacio(estrategia.acciones[1].seguimiento)){
          error = "Falta completar seguimiento en la Estrategia " + estrategia.orden + " de la Dimensión " + areaOrden;
        }
      }
      if(typeof estrategia.acciones[2] != 'undefined'){
        if (this.campoVacio(estrategia.acciones[2].seguimiento)){
          error = "Falta completar seguimiento en la Estrategia " + estrategia.orden + " de la Dimensión " +areaOrden;
        }
      }
      return error;
    }

    campoVacio(campo : string) : boolean {
        return ( campo == null || campo == "") ? true : false;
    }
  
    irA(){
      this.parent.componente="";
    }

    irAFinalizar(anio){
      Swal.fire({
        title: 'Seguimiento de Año '+anio+' finalizado con éxito',
        icon: 'success',
        confirmButtonText: 'OK'
  
      }).then(() => {
        this.parent.componente="";
        location.reload();
      })
    }
  
    volver(){
      this.guardarTodoFaseAnual();
      this.irA();
    }
  
  }
  